(() => {
  const seen = new WeakSet();
  const load = image => {
    if (image.dataset.solarSrcset) { image.srcset = image.dataset.solarSrcset; delete image.dataset.solarSrcset; }
    if (image.dataset.solarSrc) { image.src = image.dataset.solarSrc; delete image.dataset.solarSrc; }
  };
  const photoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) if (entry.isIntersecting) { load(entry.target); photoObserver.unobserve(entry.target); }
  }, {rootMargin: '450px 0px'}) : null;
  function photos(scope = document) {
    scope.querySelectorAll('img[data-solar-src]').forEach(image => {
      if (seen.has(image)) return;
      seen.add(image);
      if (photoObserver) photoObserver.observe(image); else load(image);
    });
  }
  function comparisons(scope) {
    scope.querySelectorAll('[data-compare-group]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const panels = [...group.querySelectorAll('[data-compare-panel]')];
      const tabs = [...group.querySelectorAll('[data-compare-tab]')];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let active = 0, visible = false, frame = 0, last = 0, position = 26, direction = 1, pausedUntil = 0, dragging = false;
      const boxes = panels.map(p => p.querySelector('[data-compare]'));
      const inputs = boxes.map(box => box.querySelector('input[type=range]'));
      function render(value, announce = false) {
        boxes[active].style.setProperty('--split', `${value}%`);
        inputs[active].value = Math.round(value);
        if (announce) inputs[active].setAttribute('aria-valuetext', `${Math.round(value)}% light off, ${100 - Math.round(value)}% light on`);
      }
      const allowed = () => visible && !document.hidden && !reduced.matches && group.isConnected;
      function tick(now) {
        frame = 0;
        if (!allowed()) { last = 0; return; }
        const elapsed = last ? Math.min(60, now - last) : 0; last = now;
        if (!dragging && now >= pausedUntil && !group.contains(document.activeElement)) {
          position += direction * elapsed * .010;
          if (position >= 92) { position = 92; direction = -1; }
          if (position <= 8) { position = 8; direction = 1; }
          render(position);
        }
        frame = requestAnimationFrame(tick);
      }
      function resume() { if (allowed() && !frame) { last = 0; frame = requestAnimationFrame(tick); } }
      function pause() { pausedUntil = performance.now() + 4500; }
      function select(n) {
        active = n;
        panels.forEach((panel, i) => { panel.hidden = i !== n; });
        tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === n)); tab.tabIndex = i === n ? 0 : -1; });
        position = Number(inputs[n].value); render(position, true); photos(panels[n]); resume();
      }
      panels.forEach((panel, i) => {
        const input = inputs[i];
        input.addEventListener('input', () => { position = Number(input.value); render(position, true); pause(); });
        input.addEventListener('pointerdown', () => { dragging = true; pause(); });
        input.addEventListener('keydown', pause);
        input.addEventListener('pointerup', () => { dragging = false; pause(); });
        input.addEventListener('pointercancel', () => { dragging = false; pause(); });
        input.addEventListener('blur', () => { dragging = false; pause(); resume(); });
      });
      group.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') dragging = true; });
      group.addEventListener('pointerleave', () => { dragging = false; pause(); });
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const n = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          select(n); tabs[n].focus();
        });
      });
      const visibility = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; if (!visible && frame) { cancelAnimationFrame(frame); frame = 0; last = 0; } resume(); }, {threshold: .12});
      visibility.observe(group);
      document.addEventListener('visibilitychange', resume);
      reduced.addEventListener('change', resume);
      const section = group.closest('.shopify-section');
      if (section) document.addEventListener('shopify:section:unload', event => {
        if (event.target !== section) return;
        visibility.disconnect(); cancelAnimationFrame(frame);
        document.removeEventListener('visibilitychange', resume); reduced.removeEventListener('change', resume);
      }, {once: true});
      select(0);
    });
  }
  function boot(scope = document) {
    photos(scope); comparisons(scope);
    scope.querySelectorAll('[data-feature-group]').forEach(group => {
      if (group.dataset.ready) return; group.dataset.ready = 'true';
      const tabs = [...group.querySelectorAll('[data-feature-tab]')], panels = [...group.querySelectorAll('[data-feature-panel]')];
      tabs.forEach((button, n) => button.addEventListener('click', () => {
        tabs.forEach((tab, i) => { tab.setAttribute('aria-expanded', String(i === n)); tab.querySelector('b').textContent = i === n ? '−' : '+'; });
        panels.forEach((panel, i) => { panel.hidden = i !== n; }); photos(panels[n]);
      }));
    });
    scope.querySelectorAll('.slr-mobile-menu a').forEach(link => {
      if (link.dataset.ready) return; link.dataset.ready = 'true';
      link.addEventListener('click', () => { link.closest('details').open = false; });
    });
  }
  window.solarPhotos = photos;
  document.addEventListener('shopify:section:load', event => boot(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
})();
